export default __webpack_public_path__ + "static/media/shop2.b5229f32.mp4";